module.exports = __webpack_public_path__ + "img/00_bg_04.ff646683.png";